import { Email } from "@mui/icons-material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Box, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import GlassCard from "./GlassCard";

export default function Contact(props) {
  const isMobile = useMediaQuery("(max-width: 700px)");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              width: 4,
              height: 24,
              background: "#FF83A8",
              borderRadius: "2px",
              flexShrink: 0,
            }}
          />
          <Typography
            component="h5"
            variant="h5"
            color="secondary"
            sx={{ fontFamily: "Roboto", fontWeight: 700 }}
          >
            Contact
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          maxWidth: { xs: "100%", sm: "66.67%", md: "50%" },
          mx: "auto",
          width: "100%",
        }}
      >
        <GlassCard sx={{ padding: "32px" }}>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "RobotoLight",
              fontWeight: 300,
              color: "rgba(255,255,255,0.85)",
              mb: 3,
              lineHeight: 1.8,
            }}
          >
            I'm always open to interesting conversations and opportunities. Feel
            free to reach out!
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              size="large"
              startIcon={
                <LinkedInIcon fontSize={isMobile ? "medium" : "large"} />
              }
              onClick={() => {
                window.open(
                  "https://cy.linkedin.com/in/patricia-milou",
                  "_blank",
                  "noopener,noreferrer",
                );
              }}
              sx={{
                fontFamily: "Roboto",
                fontWeight: 500,
                fontSize: "1rem",
                py: 1.5,
                px: 3,
                "&:hover": { boxShadow: "0 6px 28px rgba(255,131,168,0.10)" },
              }}
            >
              LinkedIn
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              size="large"
              startIcon={<Email fontSize={isMobile ? "medium" : "large"} />}
              href="mailto:contact@patriciamilou.com"
              sx={{
                fontFamily: "Roboto",
                fontWeight: 500,
                fontSize: "1rem",
                py: 1.5,
                px: 3,
                borderColor: "rgba(255,131,168,0.85)",
                "&:hover": {
                  borderColor: "#FF83A8",
                  background: "rgba(255,131,168,0.10)",
                },
              }}
            >
              Email
            </Button>
          </Box>
        </GlassCard>
      </Box>
      <Box>
        <Box
          component="a"
          href="https://www.youtube.com/@patriciamilou"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            textDecoration: "none",
            opacity: 0.3,
            transition: "opacity 0.4s ease",
            "&:hover": { opacity: 0.75 },
            cursor: "pointer",
            padding: "4px 8px",
            borderRadius: "4px",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              fontFamily: "RobotoLight",
              fontWeight: 300,
              fontSize: "0.7rem",
              color: "rgba(255,255,255,0.8)",
              letterSpacing: "0.5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            ✈️ Bonus: I also love travel and share my adventures on YouTube 🌍
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
